import React from 'react';
import { Link } from 'react-router-dom';

export const TabNavigation = () => {
  return(
    <div className="container row col-12 tab-nav nop">
      <div className="column col-3">
        <p><Link to="/galerie/einfahrt">Einfahrt</Link></p>
      </div>
      <div className="column col-3">
        <p><Link to="/galerie/terrasse">Terrassen</Link></p>
      </div>
      <div className="column col-3">
        <p><Link to="/galerie/zaun">Zäune</Link></p>
      </div>
      <div className="column col-3">
        <p><Link to="/galerie/garten">Garten</Link></p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/reusable/tab-navigation.js